import { Component, OnInit, ViewChild } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { DataTableDirective } from 'angular-datatables';
import { Subject } from 'rxjs';
import * as XLSX from 'xlsx';

@Component({
  selector: 'app-payable',
  templateUrl: './payable.component.html',
  styleUrls: ['./payable.component.css']
})
export class PayableComponent implements OnInit {

  @ViewChild(DataTableDirective, { static: false })
  dtOptions: DataTables.Settings = {};
  dtTrigger: Subject<any> = new Subject();
  dtElement!: DataTableDirective;
  
 

    // excelData: any[][] = [];


 selectedGroupType: string = 'partner';
 excelData: any[][] = [];
showExcel: boolean = false;

  // viewExcel() {
  //   const fileUrl = 'https://file_example_XLS_100.xls';

  //   this.http.get(fileUrl, { responseType: 'arraybuffer' }).subscribe((data) => {
  //     const workbook = XLSX.read(data, { type: 'array' });
  //     const worksheet = workbook.Sheets[workbook.SheetNames[0]];
  //     this.excelData = XLSX.utils.sheet_to_json(worksheet, { header: 1 });
  //   });
  // }

selectGroupType(type: string) {
  this.selectedGroupType = type;
}

selectedType:string = 'advisor'; 
partnerData=[];
advisorData=[];


// partnerData = [
//    { sno: 1, id:'123' ,name: 'Partner A', sreport:'' , amount: 1500, shistory:'',status: 'Active' },
//   { sno: 1, id:'123' ,name: 'Partner A', sreport:'' , amount: 1500, shistory:'',status: 'Active' },
//   { sno: 1, id:'123' ,name: 'Partner A', sreport:'' , amount: 1500, shistory:'',status: 'Active' },
//   { sno: 1, id:'123' ,name: 'Partner A', sreport:'' , amount: 1500, shistory:'',status: 'Active' },
 
// ];

  // advisorData = [
  //   {
  //     sno: 1,
  //     id: 'A001',
  //     name: 'John Doe',
  //     sreport: 'Report 1',
  //     amount: 100,
  //     shistory: 'Last month',
  //     status: 'Pending',
  //     excelFile: 'file_example_XLS_50 (4).xlsx' 
  //     // C:\Users\samreen\gb\GroupBenefitz_AdminPortal_UI\src\assets\file_example_XLS_50.xls
  //     // patsrc/assets/file_example_XLS_50.xlsh to Excel
  //   }
  // ];

// selectType(type: string) {
//   this.selectedType = type;
// }
// selectType(type: string) {
//     this.selectedType = type;
//     this.showExcel = false;
//   }
  // selectedType = '';
  // showDocViewer = false;
  // docUrl: string = '';

  // viewExcel(filePath: string) {
  //   this.http.get(filePath, { responseType: 'arraybuffer' }).subscribe(data => {
  //     const workbook = XLSX.read(data, { type: 'array' });
  //     const worksheet = workbook.Sheets[workbook.SheetNames[0]];
  //     this.excelData = XLSX.utils.sheet_to_json(worksheet, { header: 1 });
  //     this.showExcel = true;
  //   });
  // }
  selectType(type: string) {
    this.selectedType = type;
  //   setTimeout(() => {
  //   // this.rerenderDataTable();
  // }, 100)
    // this.showDocViewer = false; 
  }
  // showDocViewer = false;
  // docUrl: string = '';
  //  viewExcel() {
  //   this.docUrl = 'assets/file_example_XLS_50 (4).xlsx';
  //   this.showDocViewer = true;
  // }
  rerenderDataTable(): void {
  if (this.dtElement && this.dtElement.dtInstance) {
    this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
      dtInstance.destroy(); // destroy existing table
this.dtTrigger.next(null);
    });
  }
}





  constructor(private http: HttpClient) { }

  ngOnInit(): void {
    setTimeout(()=>{
      sessionStorage.setItem('pageName', 'Payables');
    },100)
    //  console.log('ngOnInit called');  

     this.dtOptions = {
      pagingType: 'simple_numbers',
      order: [],
       pageLength: 10,
      language: {
        searchPlaceholder: 'Search here...'
      },
      destroy: true,
    };
          

    // this.selectedType = 'advisor';
  //   setTimeout(() => {
  //   this.dtTrigger.next(null);
  // }, 0);
   this.getPayables();

  }
//   getPayables() {
//     console.log('Fetching payables...');

//   console.log('Calling getPayables()...');
//   const accessToken = sessionStorage.getItem('accessToken');
//   const url = 'http://localhost:3002/api/ap/admin-payable'; // or use [::1] if needed
//   //  const url = `${'http://[::1]:3002'}/api/ap/admin-payable`;

//   this.http.get(url, {
//     headers: {
//       Authorization: `Bearer ${accessToken}`,
//     }
//   }).subscribe({
//     next: (response: any) => {
//       console.log('Raw API Response:', response);

//       const data = response.data || response;
//       console.log('Payables Data:', data);

//       // You can store it in a component variable to display in template
//       this.payablesList = data;
//     },
//     error: (error) => {
//       console.error('Error fetching payables:', error);
//     }
//   });
// }
// getPayables() {
//   console.log('Fetching payables...');
//   const accessToken = sessionStorage.getItem('accessToken');
//   const url = 'http://localhost:3002/api/ap/admin-payable';

//   this.http.get(url, {
//     headers: {
//       Authorization: `Bearer ${accessToken}`,
//     }
//   }).subscribe({
//     next: (response: any) => {
//       console.log('Raw API Response:', response);

//       const data = response.data || response;
//       console.log('Payables Data:', data);

//       this.payablesList = data;

//       // Separate and format advisor data
//       this.advisorData = data
//         .filter((item: any) => item.recordType === 'advisor')
//         .map((item: any, index: number) => ({
//           ...item,
//           sno: index + 1,
//           sreport: item.date ? new Date(item.date).toLocaleDateString() : '-',
//           shistory: item.history?.note ?? '-'
//         }));

//       // Separate and format partner data
//       // this.partnerData = data
//       //   .filter((item: any) => item.recordType === 'partner')
//       //   .map((item: any, index: number) => ({
//       //     ...item,
//       //     sno: index + 1,
//       //     sreport: item.date ? new Date(item.date).toLocaleDateString() : '-',
//       //     shistory: item.history?.note ?? '-'
//       //   }));
//       this.partnerData = data
//   .filter((item: any) => item.recordType?.toLowerCase() === 'partner')
//   .map((item: any, index: number) => ({
//     ...item,
//     sno: index + 1,
//     sreport: item.date ? new Date(item.date).toLocaleDateString() : '-',
//     shistory: item.history?.note ?? '-'
//   }));


//       console.log('Advisor Data:', this.advisorData);
//       console.log('Partner Data:', this.partnerData);
//     },
//     error: (error) => {
//       console.error('Error fetching payables:', error);
//     }
    
//   });
//   setTimeout(() => {
//       this.dtTrigger.next(null);
//     }, 1000);

// }
getPayables() {
  console.log('Fetching payables...');
  const accessToken = sessionStorage.getItem('accessToken');
  const url = 'http://localhost:3002/api/ap/admin-payable';

  this.http.get(url, {
    headers: {
      Authorization: `Bearer ${accessToken}`,
    }
  }).subscribe({
    next: (response: any) => {
      console.log('Raw API Response:', response);

      const data = response.data || response;
      console.log('Payables Data:', data);

      this.payablesList = data;

      // Advisor data
      this.advisorData = data
        .filter((item: any) => item.recordType === 'advisor')
        .map((item: any, index: number) => ({
          ...item,
          sno: index + 1,
          sreport: item.date ? new Date(item.date).toLocaleDateString() : '-',
          shistory: item.history?.note ?? '-'
        }));

      // Partner data
      this.partnerData = data
        .filter((item: any) => item.recordType?.toLowerCase() === 'partner')
        .map((item: any, index: number) => ({
          ...item,
          sno: index + 1,
          sreport: item.date ? new Date(item.date).toLocaleDateString() : '-',
          shistory: item.history?.note ?? '-'
        }));

      console.log('Advisor Data:', this.advisorData);
      console.log('Partner Data:', this.partnerData);

      // ✅ Proper DataTable destroy and re-init logic
      setTimeout(() => {
         this.dtTrigger.next(null);
    }, 1000);
     
    },
    error: (error) => {
      console.error('Error fetching payables:', error);
    }
  });
}


payablesList: any[] = [];
  ngOnDestroy(): void {
    this.dtTrigger.unsubscribe();
  }

}